import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const GeorgiaPage = () => {
  return <DestinationTemplate destinationId="georgia" />;
};

export default GeorgiaPage;
